/*
 * This file is part of glowingblue/orell-gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export const slug = 'glowingblue-orell-gamilytics';
